import { Actions } from '../actions/rankings';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IRanking } from '../interfaces/ranking';

export type State = DeepReadonly<{
  isFetching: boolean;
  rankings: IRanking[] | null;
  error: AxiosError | null;
}>;

export const initialState: State = {
  isFetching: false,
  rankings: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_RANKINGS_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_RANKINGS_SUCCESS':
      return {
        isFetching: false,
        rankings: action.payload.sort((a, b) => a.organization.name.localeCompare(b.organization.name)),
        error: null
      };
    case 'FETCH_RANKINGS_FAILURE':
      return {
        ...state,
        isFetching: false,
        rankings: null,
        error: action.error
      };
    default:
      return state;
  }
}
